module.exports = __webpack_public_path__ + "img/bluebottle.daf1cb23.png";